const ICON_ELEMENT_SIZES = [
  "display1",
  "display2",
  "title1",
  "title2",
  "title3",
  "title4",
  "body-large",
  "body",
  "body-small",
  "inherit",
];

export default ICON_ELEMENT_SIZES;
